import BaseAuthenticator from 'ember-simple-auth/authenticators/oauth2-password-grant';
import { getOwner } from '@ember/application';

export default class OAuth2PasswordGrantAuthenticator extends BaseAuthenticator {
  constructor(...args) {
    super(...args);
    this.serverTokenEndpoint = `${this.rootURL}token`;
  }

  get rootURL() {
    return getOwner(this).resolveRegistration('config:environment').rootURL;
  }
}
